import React, { useEffect, useState } from "react";
import "../styles/AddIndepDriver.css";
import { useNavigate } from "react-router-dom";
import BusinessHubHeader from "../components/BusinessHubHeader";
import BackArrow from "../icons/BusinessHub/BackArrow";
import SuccTickIcon from "../icons/BusinessHub/SuccTickIcon";
import IndepDriverInfo from "./IndepDriverInfo";
import { userService } from "../services/userService";
import companyController from "../controllers/companyController";
import { toast } from "react-toastify";
import Utils from "../utils/Utils";
import getUser from "../controllers/userController";
import userController from "../controllers/userController";
function AddIndepDriver() {
  const navigate = useNavigate();
  const jwt = userService.getUser();
  const [childDTO, setChildDTO] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [termsPop, setTermsPop] = useState(false);
  const [ischecked, setIschecked] = useState(false);

  const handleSubmit = async () => {
    const parsed = Utils.parseJwt(jwt);

    const companyRegisterRequest = {
      companies: [
        {
          // businessProfileID: userService.getBPID(),
          // companyID: userService.getCompID(),
          companyName: childDTO.DriverName,
          companyType: "PRIMARY",
          customObject: [
            {
              attachmentStatus: "DEFAULT",
              attachmentType: "ID",
              countryName: getUser?.data?.countryOfResidence?.trim()
                ? getUser.data.countryOfResidence
                : "ZAHLE",
              customPath: "string",
              data: Utils.padBase64(childDTO?.ownerIDPassport?.base64),
              extension: childDTO?.ownerIDPassport?.name.split(".").pop(),
              objectName: childDTO?.ownerIDPassport?.name,
              userName: parsed.username,
            },
            {
              attachmentStatus: "DEFAULT",
              attachmentType: "POLICE_CLEARANCE",
              countryName: getUser?.data?.countryOfResidence?.trim()
                ? getUser.data.countryOfResidence
                : "ZAHLE",
              customPath: "string",
              data: Utils.padBase64(childDTO.DrivingLicense.base64),
              extension: childDTO.DrivingLicense.name.split(".").pop(),
              objectName: childDTO.DrivingLicense.name,
              userName: parsed.username,
            },
            {
              attachmentStatus: "DEFAULT",
              attachmentType: "PROOF_OF_LEAGALITY",
              countryName: getUser?.data?.countryOfResidence?.trim()
                ? getUser.data.countryOfResidence
                : "ZAHLE",
              customPath: "string",
              data: Utils.padBase64(childDTO.VehicleRegistration?.base64),
              extension: childDTO.VehicleRegistration?.name.split(".").pop(),
              objectName: childDTO.VehicleRegistration?.name,
              userName: parsed.username,
            },
          ],
          termsAndConditionAccepted: ischecked,
          registrationNumber: childDTO.taxNumber,
          userID: parsed.id,
          userType: "INDEVIDUAL_DRIVER ",
        },
      ],
    };

    try {
      const response = await companyController.CompanyRegistration({
        companyRegisterRequest: companyRegisterRequest,
        Authorization: jwt,
      });

      if (Utils.isSuccessResponse(response)) {
        toast.success("Registered successfully!");
        setSubmitted(true);
      }
    } catch (err) {
      console.error("Company registration failed", err);
    }
    // setSubmitted(true);
  };
  return (
    <div>
      <div className="create-intdriver-page-header">
        <BusinessHubHeader />
      </div>

      <div className="create-intdriver-content-main-container">
        {submitted && (
          <div className="edit-role-popup-container">
            <div
              className="edit-role-popup-content-container"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="edit-role-popup-content">
                <div className="edit-role-successfully-added-icon">
                  <SuccTickIcon />
                </div>
                <div className="edit-role-successfully-added-text">
                  Verification in Progress
                </div>
                <div className="comp-reg-data-review-note">
                  We are currently reviewing your legal documents, tax number,
                  and ID. Until your information is fully verified, your access
                  will remain limited as a guest. <br />
                  <b>
                    We will notify you once your account is approved and
                    activated.
                  </b>
                </div>
                <div
                  className="edit-role-successfully-added-action-button"
                  onClick={() =>
                    navigate("/user-management", { state: { active: "A" } })
                  }
                >
                  Go to Business Overview
                </div>
              </div>
            </div>
          </div>
        )}

        {termsPop && (
          <div className="intdriver-create-popup-container">
            <div
              className="intdriver-create-popup-content-container"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="intdriver-create-popup-content">
                <div className="intdriver-create-successfully-added-text">
                  Terms and Conditions
                </div>
                <div className="intdriver-create-successfully-added-icon">
                  Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed
                  diam nonummy nibh euismod tincidunt ut laoreet dolore magna
                  aliquam erat volutpat. Ut wisi enim ad minim veniam, quis
                  nostrud exerci tation ullamcorper suscipit lobortis nisl ut
                  aliquip ex ea commodo consequat. Duis autem vel eum iriure
                  dolor in hendrerit in vulputate velit esse molestie consequat,
                  vel illum dolore eu feugiat nulla facilisis at vero eros et
                  accumsan et iusto odio dignissim qui blandit praesent luptatum
                  zzril delenit augue duis dolore te feugait nulla facilisi.
                  Lorem ipsum dolor sit amet, cons ectetuer adipiscing elit, sed
                  diam nonummy nibh euismod tincidunt ut laoreet dolore magna
                  aliquam erat volutpat. Ut wisi enim ad minim veniam, quis
                  nostrud exerci tation ullamcorper suscipit lobortis nisl ut
                  aliquip ex ea commodo consequat. Lorem ipsum dolor sit amet,
                  consectetuer adipiscing elit, sed diam nonummy nibh euismod
                  tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut
                  wisi enim ad minim veniam, quis nostrud exerci tation
                  ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo
                  consequat.
                </div>
                <div
                  className="intdriver-create-successfully-added-action-button"
                  onClick={() => {
                    setTermsPop(false);
                    setIschecked(true);
                  }}
                >
                  Accept
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Main Form */}
        <div className="create-intdriver-content-container">
          <div className="create-intdriver-data-header">
            <div className="create-intdriver-header-navigation">
              <div
                className="create-intdriver-header-navigation-icon"
                onClick={() =>
                  navigate("/user-management", { state: { active: "A" } })
                }
              >
                <BackArrow />
              </div>
              <div className="create-intdriver-header-navigation-text">
                Back to Business Overview
              </div>
            </div>

            <div className="create-intdriver-header-text">
              <div className="create-intdriver-header-title">
                Add Independent Driver
              </div>
              <div className="create-intdriver-header-text-note">
                Register a new independent driver with required documentation
              </div>
            </div>
          </div>
          <div className="create-intdriver-body">
            <div className="intdriver-reg-window-container">
              <IndepDriverInfo onDataChange={setChildDTO} />

              <div className="intdriver-reg-info-input-body-doc-agree">
                <input
                  style={{ cursor: "pointer" }}
                  type="checkbox"
                  checked={ischecked}
                  onChange={(e) => setIschecked(e.target.checked)}
                />
                <div
                  style={{ cursor: "pointer" }}
                  onClick={() => setTermsPop(true)}
                >
                  I agree with the terms and conditions
                </div>
              </div>

              <div className="intdriver-reg-info-input-footer">
                {!termsPop && (
                  <div
                    className="intdriver-reg-submit-action-button"
                    onClick={handleSubmit}
                    style={{
                      opacity: ischecked ? 1 : 0.5,
                      pointerEvents: ischecked ? "auto" : "none",
                      cursor: ischecked ? "pointer" : "not-allowed",
                    }}
                  >
                    Submit
                  </div>
                )}

                <div
                  className="intdriver-reg-cancel-action-button"
                  onClick={() =>
                    navigate("/user-management", { state: { active: "A" } })
                  }
                >
                  Cancel
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddIndepDriver;
